import Component from '../abstracts/Component';

export default class ProductCardComponent extends Component {
  get SELECTORS() {
    return {
      prices: '[data-pc-prices]',
      anchorHref: '[data-pc-href]',
      oldPrice: '[data-details] .price--sale',
      currentPrice: '[data-details] .price',
      carousel: '[data-carousel="true"]:not(.slick-initialized)',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
      arrows: '[data-arrow]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.pricesBlock = this.$component.querySelector(this.SELECTORS.prices);
    this.anchor = this.$component.querySelector(this.SELECTORS.anchorHref);
  }

  importLibrary() {
    return new Promise((resolve, reject) => {
      this.moduleLoader.loadCarouselAndExecute(
        module => { resolve(module) },
        error => { reject(error) }
      );
    })
  }

  getTag(tagNumber) {
    if (isNaN(tagNumber)) {
      return;
    }
    let tagCat = this.$component.getAttribute(`data-tag-cat-${tagNumber}`);
    let tagHref = this.$component.getAttribute(`data-tag-href-${tagNumber}`);
    if (tagCat !== null && tagCat.length < 1) {
      tagCat = null;
    }
    if (tagHref !== null && tagHref.length < 1) {
      tagCat = null;
    }
    return {
      tagCat,
      tagHref,
    };
  }
  getLink() {
    return this.anchor.href;
  }
  getName() {
    return this.anchor.innerText;
  }
  getPrices() {
    let oldPrice = this.pricesBlock.querySelector(this.SELECTORS.oldPrice);
    let currPrice = this.pricesBlock.querySelector(this.SELECTORS.currentPrice);
    return {
      price: currPrice ? currPrice.innerText : null,
      oldPrice: oldPrice ? oldPrice.innerText : null,
    };
  }

  bindCarouselProduct() {
    let self = this;
    $(document).on('click mouseover', this.SELECTORS.arrows, {component : this}, function(e) {
      e.preventDefault();

      const productCard = this.closest('.w-card-product');

      if(this.parentNode.querySelector(self.SELECTORS.carousel)) {
        self.importLibrary().then(() => {
          self.getImages(self, productCard);
          self.initCarousel(productCard);
        });
      }
    });
  }

  getImages(self, target) {
    let card = target.querySelector('.c-p-card__main');
    let isDevelop = card.dataset.envDev;
    let dataGallery = target.dataset.carouselGallery;
    let imageAlt = target.dataset.imageAlt;
    // first split string and convert it to array
    let temp = dataGallery.split(',');
    $.each(temp, function(i, src) {
      if(src != '') {
        // Created elements
        let div = document.createElement('div');
        let picture = document.createElement('picture');
        let source = document.createElement('source');
        let img = document.createElement('img');

        // Set attributes to elements
        div.classList.add('product-card-img');
        picture.classList.add('main-product-image');
        if(isDevelop == 'false') {
          src = src.replace('.jpg', '.webp');
        }
        source.setAttribute('srcset', src);
        source.setAttribute('type', 'image/webp');
        img.src = src;
        img.alt = imageAlt + ' - ' + (i + 2);
        img.setAttribute('data-src', src);

        // Append elements
        picture.append(source, img);
        div.appendChild(picture);
        card.append(div);
      }
    });
  }

  initCarousel(target) {
    const opts = {
      prevArrow: target.querySelector(this.SELECTORS.prevArrow),
      nextArrow: target.querySelector(this.SELECTORS.nextArrow),
    }
    $(target).find(this.SELECTORS.carousel).slick(opts);
  }

  render() {
    super.render();
    this.bindCarouselProduct();
  }
}
